import * as Sentry from '@sentry/react'

const setTrackingUser = (email: string) => {
  try {
    Sentry.setUser({email})
  } catch (error) {
    console.error(error)
  }
}

export default setTrackingUser
